import React from "react";

export const VideoPlayer: React.FC<{ videoFile: string }> = ({ videoFile }) => {
  return (
    <div>
      <video width="650px" controls>
        <source src={videoFile} type="video/mp4" />
        Seu navegador não suporta a tag de vídeo.
      </video>
    </div>
  );
}
